export default "__VITE_ASSET__BM$aBqRf__"